module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_6000.936765f8.png";